import { isBrowser } from 'env'
import Payment from 'payment'
import { isEmpty } from 'tools/string'
import { isObjectEmpty } from 'tools/object'

export const ALPHANUMERIC_FORMAT = /^[a-zA-Z0-9]+$/
export const SHOPDOMAIN_FORMAT =
  /^(?!-)[a-zA-Z0-9-]{4,255}((?!-)[a-zA-Z0-9]|^)$/
export const COMPANY_FORMAT = /^[^<>%$]*$/
export const POSTAL_CODE_FORMATS = { en_SG: /^[0-9]{6}$/ }
export const EMAIL_FORMAT =
  /^[_A-Za-z0-9-+]+(\.[_A-Za-z0-9-+]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*(\.[A-Za-z]{2,})$/
export const NAME_FORMAT = /^((?![\d~`!@#$%^&*()_=+[\]{}\\|:;"<>/?]).){1,255}$/
export const PASSWORD_FORMAT = /^(.){8,}$/
export const PASSWORD_LOWER_UPPER_NUM_FORMAT =
  /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/
export const COLOR_HEX_FORMAT = /([0-9A-F]{6}$)|([0-9A-F]{3}$)/

export const getMenuNameError = (t, string, field) => {
  if (isEmpty(string)) {
    return t('Please enter your menu name', { field })
  }
}

export const getCompanyNameError = (t, string) => {
  if (isEmpty(string)) {
    return t('Please enter your company name')
  } else if (!COMPANY_FORMAT.test(string)) {
    return t(
      'Sorry, _string_ should not include the following special characters: < > % $',
      { string }
    )
  }
}

export const getAlphaNumericError = (t, string) => {
  if (!ALPHANUMERIC_FORMAT.test(string)) {
    return t(
      'This field should include only alphabet and numerical values with no spaces'
    )
  }
}

export const getFirstNameError = (t, string) => {
  if (!NAME_FORMAT.test(string)) {
    return t('Please enter your first name')
  }
}

export const getLastNameError = (t, string) => {
  if (!NAME_FORMAT.test(string)) {
    return t('Please enter your last name')
  }
}

export const getPhoneError = (t, string) => {
  if (
    isBrowser() &&
    window.intlTelInputUtils &&
    !window.intlTelInputUtils.isValidNumber(string)
  ) {
    return t(
      'Phone number seems to be incorrect. Please check that it is a valid number.'
    )
  }
}

export const getEmailError = (t, string) => {
  if (isEmpty(string) || !EMAIL_FORMAT.test(string)) {
    return t('Please enter a valid email address e.g. john@oddle.me')
  }
}

export const getTermsConditionsError = (t, termsConditionsCheckbox) => {
  if (!termsConditionsCheckbox) {
    return t('Please accept Terms & Conditions and Privacy Policy')
  }
}

export const getShopdomainError = (t, string) => {
  if (isEmpty(string) || !SHOPDOMAIN_FORMAT.test(string)) {
    return t(
      'Sorry, _string_ is not a valid shop domain name, domain name should have at least 4 characters and only include alphabets and numbers',
      { string: string || t('this') }
    )
  }
}

export const getEmptyPasswordError = (t, string) => {
  if (isEmpty(string)) {
    return t('Please ensure the password contains at least 8 characters')
  }
}

export const getPasswordError = (t, string) => {
  if (isEmpty(string) || !PASSWORD_FORMAT.test(string)) {
    return t('Please ensure the password contains at least 8 characters')
  }
}

export const getPasswordLowerUpperNumError = (t, string = '') => {
  if (isEmpty(string) || !PASSWORD_LOWER_UPPER_NUM_FORMAT.test(string)) {
    return t(
      'Please ensure the password contains at least 8 characters, 1 uppercase character, and 1 numerical character'
    )
  }
}

export const getRePasswordError = (
  t,
  string1,
  string2,
  newPassword = false
) => {
  if (!isEmpty(string1) && string1 !== string2) {
    if (newPassword) {
      return t('Please ensure the new passwords are matched')
    } else {
      return t('The passwords do not match')
    }
  }
}

export const getAddressError = (t, object) => {
  const requiredField = [
    'formattedAddress',
    'addressOne',
    'autoCompleteAddress',
    'address',
    'country'
  ]
  if (isObjectEmpty(object)) {
    return t('Please enter a valid address')
  } else {
    if (
      requiredField.some(
        (key) => object.hasOwnProperty(key) && isEmpty(object[key])
      )
    ) {
      return t(
        'The address given looks incorrect, try entering an address with a street name'
      )
    }
  }
}

export const getCardNameError = (t, string) => {
  if (isEmpty(string)) {
    return t('Please enter your card name')
  }
}

export const getChargebeePlanError = (t, string) => {
  if (isEmpty(string)) {
    return t('Please select a subscription plan or choose none')
  }
}

export const getCardError = (t, card) => {
  if (
    isEmpty(card.cardNumber) ||
    !Payment.fns.validateCardNumber(card.cardNumber)
  ) {
    return t('Please enter valid card number')
  } else if (
    isEmpty(card.cardExpiry) ||
    !Payment.fns.validateCardExpiry(card.cardExpiry)
  ) {
    return t('Please enter valid card expiry')
  } else if (isEmpty(card.cvc) || !Payment.fns.validateCardCVC(card.cvc)) {
    return t('Please enter valid card CVC')
  }
}

export const getPaymentMethodError = (t, paymentMethod) => {
  if (isObjectEmpty(paymentMethod)) {
    return t('Please choose any payment methods provided')
  } else if (!isObjectEmpty(paymentMethod) && isEmpty(paymentMethod.id)) {
    return t('Please choose any payment methods provided')
  }
}
